import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import media from 'styled-media-query';
import styled from 'styled-components';

import { State } from 'src/state/ducks';
import { BakedBreadEntity } from 'src/firebase/db/BakedBreads';
import { NotificationTemplateBakedBreadEntity } from 'src/firebase/db/NotificationTemplates';

import StyleConfig from 'src/constants/StyleConfig';

type Props = {
  notificationTemplateBakedBread: NotificationTemplateBakedBreadEntity;
  bakedBreads: BakedBreadEntity[];
};

const NotificationTemplateConfirmBakedBread = (props: Props) => {
  const { notificationTemplateBakedBread, bakedBreads } = props;

  const { ref, maximum_order, stock } = notificationTemplateBakedBread;

  const bakedBread = useMemo(() => bakedBreads.find((v) => v.id === ref.id) as BakedBreadEntity, [
    bakedBreads,
    ref,
  ]);

  return (
    <BakedBread>
      <div className="bakedBread-image">
        <img src={bakedBread.image} alt={bakedBread.name} />
      </div>
      <div className="bakedBread-name">
        <span>{bakedBread.name}</span>
      </div>
      <div className="bakedBread-quantity">
        <p>
          <span>販売個数</span>
          <span>{stock}個</span>
        </p>
        <p>
          <span>購入上限数</span>
          <span>{maximum_order}個</span>
        </p>
      </div>
    </BakedBread>
  );
};

const BakedBread = styled.div`
  line-height: ${24 / 16};
  font-weight: bold;
  color: ${StyleConfig.COLOR.TEXT_COLOR};
  padding: 0 ${StyleConfig.HELPER.M16};
  ${media.greaterThan('medium')`
    padding: 20px ${StyleConfig.HELPER.M16};
  `};
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  &:not(:last-child) {
    border-bottom: 1px solid ${StyleConfig.COLORS.GRAY6};
  }

  .bakedBread-image {
    width: 84px;
    height: 84px;
    overflow: hidden;
    position: relative;
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      width: 100%;
      height: auto;
    }
    flex: 20%;
  }
  .bakedBread-name {
    margin-right: auto;
    padding-left: 10px;
    flex: 40%;
  }
  .bakedBread-quantity {
    margin-left: auto;
    flex: 40%;
    text-align: right;
    font-weight: normal;
    p {
      display: inline-flex;
      width: 100%;
      span:first-child {
        flex-grow: 2;
      }
      span:last-child {
        width: 40px;
      }
    }
  }
`;
const mapStateToProps = (state: State) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(NotificationTemplateConfirmBakedBread);
